// Tickt einmal pro Sekunde - wird zentral einmal im Hauptwidget erzeugt und an MatchCard
// weitergereicht, damit nicht jede Karte ihren eigenen Timer aufmacht.
import { ref, onUnmounted } from 'vue'

export function useClock() {
  // BUGFIX: new Date().getTime() statt Date.now() - auf manchen Host-Seiten wird die globale
  // Date.now-Funktion von einem anderen Script überschrieben (monkey-patched) und liefert dann
  // fälschlich ein Date-Objekt statt einer Zahl zurück (bestätigt per Date.now.toString() auf
  // der betroffenen Seite: "function(){return new Date();}" statt nativem Code). new Date()
  // selbst war davon nicht betroffen, .getTime() liefert also zuverlässig die Millisekunden-Zahl.
  const jetzt = ref(new Date().getTime())
  const timer = setInterval(() => { jetzt.value = new Date().getTime() }, 1000)

  onUnmounted(() => clearInterval(timer))

  return { jetzt }
}